import { gql } from "@apollo/client";

export const ADDITIONAL_DATA_INPUT_MUTATION = gql`
  mutation updateOffersAdditionalData($input: AdditionalDataInput!) {
    updateOffersAdditionalData(input: $input) {
      correlationId
    }
  }
`;

export const OFFER_CLIENT_FACILITIES_INPUT_MUTATION = gql`
  mutation offerClientFacilities($input: OfferClientFacilitiesInput!) {
    offerClientFacilities(input: $input) {
      correlationId
    }
  }
`;

export const VARIABLE_INTEREST_MUTATION = gql`
  mutation computeVariableInterest($input: ComputeVariableInterestInput!) {
    computeVariableInterest(input: $input) {
      correlationId
    }
  }
`;
